// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-parts-modal[data-v-6c372b88]{border-radius:15px}", ""]);
// Exports
module.exports = exports;
